import React from "react";

function LabourBillingSetupComponent(){
    return (
        <h1> Labour billing Setup</h1>
    )
}

export default LabourBillingSetupComponent